// extracted by mini-css-extract-plugin
export var dropdownContainer = "_oz-0";
export var leftAlign = "_oz-4";
export var listItem = "_oz-2";
export var listItemWrapper = "_oz-1";
export var operationText = "_oz-3";